import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.347 15.521c.699-1.16 1.39-2.712 1.589-4.521h1.974a6.013 6.013 0 0 1-3.563 4.521zM4.09 11h1.975c.198 1.809.889 3.361 1.589 4.521A6.017 6.017 0 0 1 4.09 11zm3.564-6.521c-.7 1.16-1.391 2.712-1.59 4.521H4.09a6.017 6.017 0 0 1 3.564-4.521zM8.077 9c.269-1.916 1.239-3.52 1.925-4.443.687.92 1.655 2.519 1.922 4.443H8.077zm1.92 6.443c-.685-.919-1.653-2.519-1.921-4.443h3.847c-.27 1.916-1.24 3.521-1.925 4.443zM15.91 9h-1.974c-.198-1.809-.89-3.361-1.59-4.521A6.013 6.013 0 0 1 15.91 9zM10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8c4.41 0 8-3.589 8-8s-3.59-8-8-8z"
});

var SvgGlobeMinor = function SvgGlobeMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgGlobeMinor as S };
